import { Link } from 'react-router-dom';

/**
 * Shown for any address that matches no route. Without it React Router renders
 * an empty page, which reads as a broken site rather than a wrong address.
 */
function NotFound() {
  return (
    <div className="card mt-10">
      <div className="card-body text-center py-20">
        <h1 className="fw-bold text-gray-800 mb-4">Page not found</h1>
        <p className="text-gray-600 mb-10">
          That address does not exist. It may have been mistyped, or the page may have moved.
        </p>
        <Link to="/overview" className="btn btn-primary">Back to your dashboard</Link>
      </div>
    </div>
  );
}

export default NotFound;
